import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { SearchQuery, SearchResponse, TreeUser, TreeUserResponse } from '../model/users-model';

@Injectable()
export class UsersApiService {
  constructor(private _http: HttpClient) {}

  getUsersQuery(parameters: SearchQuery): Observable<SearchResponse> {
    return this._http.post<any>(environment.URL_BASE_ADMIN + environment.subUrlSearchUsers, parameters);
  }

  getUserHierarchy(parameters: TreeUser): Observable<TreeUserResponse> {
    return this._http.post<any>(environment.URL_BASE_ADMIN + environment.subUrlGetUserTree, parameters);
  }
}
